module.exports = __webpack_public_path__ + "img/icon.73959d2e.png";